import image0 from './images/approval.png';
import image1 from './images/change-answer.png';
import image2 from './images/check-list-answer.png';
import image3 from './images/declaration.png';
import image4 from './images/feedback.png';
import image5 from './images/form-entry.png';
import image6 from './images/form-overview.png';
import image7 from './images/input-method-panel.png';
import image8 from './images/list-method.png';
import image9 from './images/list-summary.png';
import image10 from './images/my-forms.png';
import image11 from './images/nil-not-selected.png';
import image12 from './images/nil-selected.png';
import image13 from './images/online-table.png';
import image14 from './images/question-page.png';
import image15 from './images/register-email.png';
import image16 from './images/register-start.png';
import image17 from './images/reset-password.png';
import image18 from './images/share-form.png';
import image19 from './images/sign-in.png';

export default `<!doctype html>
<html lang="en-gb">
  <head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <meta name="description" content="Simple instructions for using the PSFA Consolidated Data Request form.">
    <title>PSFA CDR user guide</title>
    <link rel="stylesheet" href="styles.css">
  </head>
  <body>
    <a class="skip-link" href="#main-content">Skip to main content</a>

    <header class="site-header">
      <div class="page-width header-inner">
        <span class="govuk-wordmark">GOV.UK</span>
        <span class="service-name">PSFA CDR user guide</span>
      </div>
    </header>

    <div class="service-bar">
      <div class="page-width">Public Sector Fraud Authority</div>
    </div>

    <main id="main-content" class="page-width">
      <section class="intro" aria-labelledby="page-title">
        <p class="eyebrow">Consolidated Data Request</p>
        <h1 id="page-title">How to use the PSFA form</h1>
        <p class="lead">Short instructions for setting up your account, completing a form and sending it to PSFA.</p>
      </section>

      <div class="guide-layout">
        <nav class="contents" aria-label="Guide contents">
          <h2>Contents</h2>
          <h3>Account and sign in</h3>
          <ol>
            <li><a href="#account">Register for an account</a></li>
            <li><a href="#sign-in">Sign in</a></li>
            <li><a href="#password">Reset your password</a></li>
          </ol>
          <h3>Forms and answers</h3>
          <ol start="4">
            <li><a href="#start">Start a new form</a></li>
            <li><a href="#continue">Find and continue a form</a></li>
            <li><a href="#overview">Understand the form overview</a></li>
            <li><a href="#questions">Answer questions</a></li>
            <li><a href="#change-answer">Change an existing answer</a></li>
            <li><a href="#save">Save draft answers</a></li>
          </ol>
          <h3>Lists and Excel</h3>
          <ol start="10">
            <li><a href="#nil-return">Record a nil return</a></li>
            <li><a href="#lists">Choose or change how to complete a list</a></li>
            <li><a href="#table">Use the online table</a></li>
            <li><a href="#excel">Use Excel</a></li>
            <li><a href="#list-summary">Understand a list summary</a></li>
          </ol>
          <h3>Sharing and sending</h3>
          <ol start="15">
            <li><a href="#share">Share a form</a></li>
            <li><a href="#approval">Send a form for approval</a></li>
            <li><a href="#submit">Submit a form to PSFA</a></li>
          </ol>
          <h3>Help</h3>
          <ol start="18">
            <li><a href="#feedback">Give feedback</a></li>
            <li><a href="#help">Get help</a></li>
          </ol>
        </nav>

        <div class="guide">
          <section id="account" class="task task-wide">
            <div class="task-copy">
              <span class="step-number">1</span>
              <h2>Register for an account</h2>
              <ol>
                <li>On the sign-in page, select <strong>Create an account</strong>.</li>
                <li>Enter your work email address.</li>
                <li>Select <strong>Continue</strong>.</li>
                <li>Open the email containing your sign-in details.</li>
                <li>Return to the sign-in page and enter your email address and temporary password.</li>
                <li>Create a new password when asked.</li>
              </ol>
              <p>Check your junk or spam folder if the email has not arrived.</p>
            </div>
            <div class="screenshot-pair">
              <figure class="screenshot">
                <img src="${image16}" alt="PSFA sign-in page with a Create an account button beside Sign in.">
                <figcaption>Select Create an account</figcaption>
              </figure>
              <figure class="screenshot">
                <img src="${image15}" alt="PSFA Create an account page with an email address field and Continue button." loading="lazy">
                <figcaption>Enter your email address, then select Continue</figcaption>
              </figure>
            </div>
          </section>

          <section id="sign-in" class="task">
            <div class="task-copy">
              <span class="step-number">2</span>
              <h2>Sign in</h2>
              <ol>
                <li>Go to the PSFA form and select <strong>Sign in</strong>.</li>
                <li>Enter your registered email address and password.</li>
                <li>Select <strong>Sign in</strong>.</li>
              </ol>
            </div>
            <figure class="screenshot">
              <img src="${image19}" alt="PSFA sign-in page with email address, password and Sign in controls." loading="lazy">
              <figcaption>PSFA sign-in page</figcaption>
            </figure>
          </section>

          <section id="password" class="task">
            <div class="task-copy">
              <span class="step-number">3</span>
              <h2>Reset your password</h2>
              <ol>
                <li>On the sign-in page, select <strong>Forgot password?</strong></li>
                <li>Enter your registered email address and select <strong>Continue</strong>.</li>
                <li>Open the email and copy the verification code.</li>
                <li>Enter the code and your new password.</li>
              </ol>
              <p>Your password must contain at least 10 characters and a lowercase letter.</p>
            </div>
            <figure class="screenshot">
              <img src="${image17}" alt="PSFA Reset password page with an email address field and Continue button." loading="lazy">
              <figcaption>Reset password page</figcaption>
            </figure>
          </section>

          <section id="start" class="task">
            <div class="task-copy">
              <span class="step-number">4</span>
              <h2>Start a new form</h2>
              <ol>
                <li>Go to <strong>My Forms</strong>.</li>
                <li>Select <strong>Start a new form</strong>.</li>
                <li>Complete the organisation details first. This gives the form its identifier and reporting period.</li>
              </ol>
            </div>
            <figure class="screenshot">
              <img src="${image10}" alt="PSFA My Forms page with Start a new form and Continue buttons." loading="lazy">
              <figcaption>My Forms</figcaption>
            </figure>
          </section>

          <section id="continue" class="task">
            <div class="task-copy">
              <span class="step-number">5</span>
              <h2>Find and continue a form</h2>
              <ol>
                <li>Go to <strong>My Forms</strong>.</li>
                <li>Find the form using its identifier, reporting period and status.</li>
                <li>Select <strong>Continue</strong>.</li>
              </ol>
              <p>You may see <strong>Review</strong> or <strong>View</strong> instead, depending on the form's status.</p>
            </div>
            <figure class="screenshot">
              <img src="${image10}" alt="PSFA My Forms table showing reporting period, role, status and Continue." loading="lazy">
              <figcaption>Find the correct row, then select Continue</figcaption>
            </figure>
          </section>

          <section id="overview" class="task">
            <div class="task-copy">
              <span class="step-number">6</span>
              <h2>Understand the form overview</h2>
              <p>The overview groups questions into numbered sections. Select a blue question name to open it.</p>
              <ul>
                <li><strong>Not Started</strong> - no saved answer.</li>
                <li><strong>In Progress</strong> - saved as unfinished or missing required answers.</li>
                <li><strong>Completed</strong> - required answers are complete.</li>
                <li><strong>Nil Return</strong> - you have said there is nothing to report.</li>
              </ul>
              <p>The three-line symbol means the question can contain several responses.</p>
            </div>
            <figure class="screenshot">
              <img src="${image6}" alt="Detected section of the PSFA form overview with three list questions, repeatable-question symbols, nil-return buttons and Not Started statuses." loading="lazy">
              <figcaption>A section on the form overview</figcaption>
            </figure>
          </section>

          <section id="questions" class="task">
            <div class="task-copy">
              <span class="step-number">7</span>
              <h2>Answer questions</h2>
              <ul>
                <li>A red <strong>*</strong> means you must answer the question.</li>
                <li><strong>(optional)</strong> means you can leave it blank.</li>
              </ul>
              <p>Enter or select your answer, then use a save button at the bottom of the page.</p>
            </div>
            <figure class="screenshot screenshot-tall">
              <img src="${image14}" alt="Real PSFA question page showing required red stars, optional labels, fields and save buttons." loading="lazy">
              <figcaption>Required and optional questions</figcaption>
            </figure>
          </section>

          <section id="change-answer" class="task">
            <div class="task-copy">
              <span class="step-number">8</span>
              <h2>Change an existing answer</h2>
              <ol>
                <li>Open <strong>Check your answers</strong> from the form overview.</li>
                <li>Find the question and select <strong>Change</strong>.</li>
                <li>Update the answer and select <strong>Save and continue</strong>.</li>
              </ol>
              <p>For a list response, open its list page and select <strong>Change</strong> beside the response.</p>
            </div>
            <figure class="screenshot">
              <img src="${image1}" alt="Submitting Department and Area answers with Completed status and a Change link." loading="lazy">
              <figcaption>Change an answer from Check your answers</figcaption>
            </figure>
          </section>

          <section id="save" class="task">
            <div class="task-copy">
              <span class="step-number">9</span>
              <h2>Save draft answers</h2>
              <div class="save-notes">
                <p><strong>Save and continue</strong> - check required answers, save and leave the page.</p>
                <p><strong>Save as unfinished</strong> - save what you have entered, even if required answers are missing.</p>
              </div>
              <p class="important">Answers are not saved automatically. Select a save button before leaving the page.</p>
            </div>
            <figure class="screenshot screenshot-tall">
              <img src="${image14}" alt="PSFA question page ending with Save and continue and Save as unfinished buttons." loading="lazy">
              <figcaption>Save buttons at the bottom of a question page</figcaption>
            </figure>
          </section>

          <section id="nil-return" class="task task-wide">
            <div class="task-copy">
              <span class="step-number">10</span>
              <h2>Record a nil return</h2>
              <ol>
                <li>Find the relevant question on the form overview.</li>
                <li>Select its grey <strong>NIL RETURN</strong> button.</li>
                <li>Check that the button turns green and the status says <strong>Nil Return</strong>.</li>
              </ol>
              <p>Select the green button to clear the nil return. The button is not shown after responses have been added. In that case, open the question and change its declaration answer.</p>
            </div>
            <div class="screenshot-pair">
              <figure class="screenshot">
                <img src="${image11}" alt="Detected fraud overview row with grey NIL RETURN button and Not Started status." loading="lazy">
                <figcaption>Not selected</figcaption>
              </figure>
              <figure class="screenshot">
                <img src="${image12}" alt="Detected error overview row with green NIL RETURN button and Nil Return status." loading="lazy">
                <figcaption>Selected</figcaption>
              </figure>
            </div>
          </section>

          <section id="lists" class="task">
            <div class="task-copy">
              <span class="step-number">11</span>
              <h2>Choose or change how to complete a list</h2>
              <p>The first time you open a list question, choose:</p>
              <ul>
                <li><strong>Table format</strong> - enter several rows in one table.</li>
                <li><strong>Web form</strong> - enter one response at a time in a guided form.</li>
              </ul>
              <p>Select an option, then select <strong>Continue</strong>. Your choice is remembered in this browser.</p>
              <p>To change it later:</p>
              <ol>
                <li>Open a list question.</li>
                <li>Check the current choice under <strong>Input method</strong>.</li>
                <li>Select <strong>Change input method</strong>.</li>
                <li>Select the other option, then select <strong>Continue</strong>.</li>
              </ol>
              <p><strong>Selected</strong> marks your current choice.</p>
            </div>
            <div class="screenshot-stack">
              <figure class="screenshot">
                <img src="${image7}" alt="PSFA Input method panel showing Web form and the purple Change input method button." loading="lazy">
                <figcaption>Check the current choice, then select Change input method</figcaption>
              </figure>
              <figure class="screenshot">
                <img src="${image8}" alt="PSFA input method selector with illustrated Table format and Web form cards, Web form selected, Continue and Cancel." loading="lazy">
                <figcaption>Select an option, then select Continue</figcaption>
              </figure>
            </div>
          </section>

          <section id="table" class="task task-wide">
            <div class="task-copy">
              <span class="step-number">12</span>
              <h2>Use the online table</h2>
              <ol>
                <li>Choose <strong>Table format</strong>.</li>
                <li>Enter information in each row. A red <strong>*</strong> marks a required column.</li>
                <li>Select <strong>Add row</strong> for more responses, or <strong>Paste from clipboard</strong> to copy spreadsheet rows.</li>
                <li>Fix any errors, then select <strong>Save changes</strong>.</li>
              </ol>
              <p>Use the blue <strong>i</strong> buttons to read guidance for a column.</p>
            </div>
            <figure class="screenshot screenshot-full">
              <img src="${image13}" alt="Real PSFA online table with rows, required columns, Add row, Paste from clipboard, Excel controls and Save changes." loading="lazy">
              <figcaption>Online table</figcaption>
            </figure>
          </section>

          <section id="excel" class="task task-wide">
            <div class="task-copy">
              <span class="step-number">13</span>
              <h2>Use Excel</h2>
              <ol>
                <li>Open the list in <strong>Table format</strong>.</li>
                <li>Select <strong>Download Excel template</strong>.</li>
                <li>Enter your information without changing the column headings.</li>
                <li>Return to the online table and select <strong>Upload Excel template</strong>.</li>
                <li>Choose the XLSX file, check the imported rows and select <strong>Save changes</strong>.</li>
              </ol>
              <p class="important">Upload uses the PSFA Excel template. It does not upload another workbook layout.</p>
            </div>
            <figure class="screenshot screenshot-full">
              <img src="${image13}" alt="PSFA online table showing Download Excel template and Upload Excel template buttons." loading="lazy">
              <figcaption>Excel controls are below the online table</figcaption>
            </figure>
          </section>

          <section id="list-summary" class="task task-wide">
            <div class="task-copy">
              <span class="step-number">14</span>
              <h2>Understand a list summary</h2>
              <ul>
                <li><strong>Totals</strong> combine the number and value from all saved responses.</li>
                <li><strong>Response 1</strong>, <strong>Response 2</strong> and so on are separate saved items.</li>
                <li><strong>Completed</strong> means required answers for that response are complete.</li>
                <li><strong>In Progress</strong> means the response still needs an answer.</li>
                <li><strong>Change</strong> edits a response. <strong>Remove</strong> deletes it.</li>
                <li><strong>Add another</strong> creates another response. <strong>Continue</strong> leaves the list.</li>
              </ul>
              <p>On <strong>Check your answers</strong>, the blue response count shows how many responses were saved. Select <strong>View</strong> to return to the list.</p>
            </div>
            <div class="screenshot-stack">
              <figure class="screenshot">
                <img src="${image9}" alt="Detected fraud list summary with totals, Response 1, Completed status, Change, Remove, Add another and Continue." loading="lazy">
                <figcaption>Summary on the list page</figcaption>
              </figure>
              <figure class="screenshot">
                <img src="${image2}" alt="Detected fraud section on Check your answers with totals, Completed status, one response and View links." loading="lazy">
                <figcaption>The same list on Check your answers</figcaption>
              </figure>
            </div>
          </section>

          <section id="share" class="task">
            <div class="task-copy">
              <span class="step-number">15</span>
              <h2>Share a form</h2>
              <ol>
                <li>Open the form and select <strong>Share</strong>.</li>
                <li>Enter the person's sign-in email address.</li>
                <li>Choose <strong>Read Only</strong>, <strong>Editor</strong> or <strong>Approver</strong>.</li>
                <li>Choose <strong>Current form only</strong>, or all forms in your PSFA account.</li>
                <li>Select <strong>Add user</strong>.</li>
              </ol>
              <p>Only give the person the access they need.</p>
            </div>
            <figure class="screenshot">
              <img src="${image18}" alt="Real PSFA sharing controls for email, role, scope and Add user." loading="lazy">
              <figcaption>Share controls</figcaption>
            </figure>
          </section>

          <section id="approval" class="task task-wide">
            <div class="task-copy">
              <span class="step-number">16</span>
              <h2>Send a form for approval</h2>
              <ol>
                <li>Open <strong>Check your answers</strong> and check the form.</li>
                <li>Under <strong>Please select the next step</strong>, choose internal approval or parent organisation approval.</li>
                <li>Select an approver. If none is listed, choose <strong>Choose another approver</strong> and enter their email address.</li>
                <li>Add notes if needed.</li>
                <li>Select <strong>Submit your form for approval</strong>.</li>
              </ol>
            </div>
            <figure class="screenshot screenshot-full">
              <img src="${image0}" alt="Real PSFA approval controls with next step, approver, email, optional notes and Submit your form for approval." loading="lazy">
              <figcaption>Approval controls at the bottom of Check your answers</figcaption>
            </figure>
          </section>

          <section id="submit" class="task">
            <div class="task-copy">
              <span class="step-number">17</span>
              <h2>Submit a form to PSFA</h2>
              <ol>
                <li>Open <strong>Check your answers</strong>.</li>
                <li>Under <strong>Please select the next step</strong>, choose <strong>Submit the form to PSFA for their review</strong>.</li>
                <li>Select <strong>Submit your form</strong>.</li>
                <li>Read the declaration and tick <strong>I agree</strong>.</li>
                <li>Select <strong>Submit your form</strong>.</li>
              </ol>
              <p class="important">Check every answer before submitting.</p>
            </div>
            <figure class="screenshot">
              <img src="${image3}" alt="Real PSFA declaration with I agree checkbox and Submit your form button." loading="lazy">
              <figcaption>Declaration page</figcaption>
            </figure>
          </section>

          <section id="feedback" class="task">
            <div class="task-copy">
              <span class="step-number">18</span>
              <h2>Give feedback</h2>
              <ol>
                <li>Select <strong>feedback</strong> in the banner at the top of any form page.</li>
                <li>Choose whether to share your email address with the form owner.</li>
                <li>Enter your feedback and select <strong>Submit</strong>.</li>
              </ol>
            </div>
            <figure class="screenshot">
              <img src="${image4}" alt="Real PSFA feedback popup with email-sharing choice, feedback box, Submit and Cancel." loading="lazy">
              <figcaption>Feedback popup</figcaption>
            </figure>
          </section>

          <section id="help" class="task task-text-only">
            <div class="task-copy">
              <span class="step-number">19</span>
              <h2>Get help</h2>
              <p>For account, sign-in or form problems, email <a href="mailto:grid-platform@cabinetoffice.gov.uk">grid-platform@cabinetoffice.gov.uk</a>.</p>
              <p>Include:</p>
              <ul>
                <li>the page you were using</li>
                <li>what you tried to do</li>
                <li>what happened</li>
              </ul>
              <p class="important">Do not send passwords or sensitive information.</p>
            </div>
          </section>
        </div>
      </div>
    </main>

    <footer class="site-footer">
      <div class="page-width">
        <p>Public Sector Fraud Authority</p>
        <a href="mailto:grid-platform@cabinetoffice.gov.uk">Contact GRID support</a>
      </div>
    </footer>
  </body>
</html>
`;
